/* Svensk katalog for locale-purchases-reports-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'buy.remove': 'Ta bort',
  'buy.openPreview': 'Öppna förhandsgranskning',
  'buy.noPreview': 'Ingen förhandsgranskning',
  'buy.savedInBackend': 'Verifikationen är sparad.',
  'buy.open': 'Öppna',
  'buy.addMoreDocs': 'Lägg till fler verifikationer',
  'buy.addMoreDocsHelp': 'Bifoga fler kvitton eller sidor till samma inköp. Alla bifogade verifikationer listas här.',
  'buy.uploadDoc': 'Ladda upp verifikation',
  'buy.uploadDocHelp': 'Bifoga kvittot eller fakturan för inköpet. Du kan dra in en fil, välja från datorn eller hämta en verifikation från inkorgen.',
  'buy.dropOrPick': 'Släpp eller välj verifikation',
  'buy.storedIn': 'PDF eller bild sparas i Firebase/inkorgen.',
  'buy.fromInbox': 'Hämta från inkorg',
  'buy.attachments': 'Bilagor',
  'buy.pickFiles': 'Välj filer',
  'buy.dropAttachments': 'Släpp bilagor här',
  'buy.attachmentsNote': 'Bilagor laddas upp till backend när bokningen sparas.',
  'buy.supplierSearch': 'Sök eller lägg till leverantör...',
  'buy.supplierSearchShort': 'Sök eller lägg till leverantör',
  'buy.supplierClose': 'Stäng leverantörsval',
  'buy.supplierNone': 'Inga leverantörer hittades.',
  'buy.supplierNew': 'Ny leverantör',
  'buy.name': 'Namn',
  'buy.org': 'Org.nr',
  'buy.email': 'E-post',
  'buy.phone': 'Telefon',
  'buy.accountClose': 'Stäng kontoval',
  'buy.searchShort': 'Sök ...',
  'buy.noAccountMatch': 'Inget konto matchar sökningen.',
  'buy.fromInboxRead': 'Hämtad från inkorgen - SuperPlumma har läst av det vi kunde.',
  'buy.docHelp': 'Verifikationen är kvittot eller fakturan som dokumenterar inköpet. Dra in en bild eller en PDF - eller tryck för att välja fil. SuperPlumma läser av datum, belopp, leverantör och moms och föreslår hur inköpet ska bokföras.',
  'buy.dropReceipt': 'Släpp kvittot här',
  'buy.dropReceiptHelp': 'Hämta verifikationen från dina filer, eller välj ”Hämta från inkorg” för att använda en verifikation som redan har kommit in via e-post. SuperPlumma läser av innehållet automatiskt.',
  'buy.upload': 'Ladda upp',
  'buy.type': 'Typ av inköp',
  'buy.typeHelp': 'Välj hur inköpet ska registreras. ”Betalt inköp” är ett inköp som redan är betalt. ”Leverantörsfaktura” används när fakturan ska betalas senare eller är delbetald (blir en leverantörsskuld). ”Utkast” visar påbörjade inköp som du inte har bokfört ännu.',
  'buy.description': 'Beskrivning',
  'buy.descriptionPh': 'T.ex. abonnemang eller resa',
  'buy.toggleVat': 'Växla mellan exkl. och inkl. moms',
  'buy.amountExInc': 'Belopp exkl./inkl. moms',
  'buy.amountExIncHelp': 'Tryck för att växla mellan att ange beloppet utan moms (netto) eller med moms (brutto). Plumme räknar automatiskt om mellan de två. ”Exkl. moms” är själva kostnaden, ”inkl. moms” är totalbeloppet du betalade.',
  'buy.vatRate': 'Momssats',
  'buy.vatRateHelp': 'Momssatsen på inköpet. 25 % är normalsatsen, 15 % gäller livsmedel (mat), 12 % gäller bl.a. persontransport och övernattning, och 0 % används för momsfria inköp. Momsen på ett inköp är ingående moms, som du får avdrag för.',
  'buy.pickCategory': 'Konto/kategori',
  'buy.category': 'Kategori',
  'buy.categoryHelp': 'Vilken typ av kostnad detta är. Kategorin avgör vilket konto inköpet bokförs på, så att det hamnar rätt i resultaträkningen och skattemeldingen.',
  'buy.supplier': 'Leverantör',
  'buy.accountFromHistory': 'Kostnadskonto föreslaget utifrån tidigare inköp hos leverantören. Du kan ändra det på inköpsraden.',
  'buy.date': 'Inköpsdatum',
  'buy.invoiceNumber': 'Fakturanummer',
  'buy.invoiceNumberPh': 'T.ex. 100245',
  'buy.dueDate': 'Förfallodatum',
  'buy.lines': 'Rader',
  'buy.linesHelp': 'Varje rad är en kostnad på verifikationen, med eget belopp, momssats och kategori. Har kvittot flera olika varor eller momssatser skapar du en rad per typ. Du kan dra raderna för att ändra ordning.',
  'buy.addLine': 'Lägg till rad',
  'buy.payment': 'Betalning',
  'buy.paymentHelp': 'För leverantörsfaktura väljer du om fakturan är betald. Obetalda fakturor sparas som öppen leverantörsskuld, så att betalningen kan registreras senare.',
  'buy.immediatePaymentHelp': 'Ett vanligt inköp är redan betalt. Välj vilket konto betalningen gjordes från och datumet då den betalades.',
  'buy.paid': 'Betald',
  'buy.unpaid': 'Inte betald',
  'buy.paidFrom': 'Betald från',
  'buy.choosePaymentSource': 'Välj betalningskälla',
  'buy.paidDate': 'Betalningsdatum',
  'buy.paidDateHelp': 'Datumet då inköpet betalades. Inköpsdatumet styr redovisnings- och momsperioden för själva inköpet.',
  'buy.dateLabel': 'Datum',
  'buy.addPartPayment': 'Lägg till delbetalning',
  'buy.addPartPaymentHelp': 'Registrera ytterligare en betalning. Summan av delbetalningarna dras från totalen - det som återstår visas som ”återstår”.',
  'buy.remaining': 'Återstår',
  'buy.remainingHelp': 'Skillnaden mellan totalbeloppet och det du har registrerat som delbetalningar. Är den 0 är inköpet helt reglerat.',
  'buy.preview': 'Förhandsgranskning',
  'buy.previewHelp': 'Förhandsgranskning av verifikationen du har laddat upp. Har du inte laddat upp någon verifikation kan du göra det här.',
  'buy.dropReceiptLong': 'Släpp kvittot här - dra in en bild eller PDF, eller tryck för att välja fil.',
  'buy.summaryHelp': 'Sammanfattningen visar netto, moms och totalsumman du betalar.',
  'buy.saveDraft': 'Spara utkast',
  'buy.saveDraftHelp': 'Sparar inköpet som ett utkast utan att bokföra det. Verifikationer och betalningar markeras inte som bokförda förrän du slutför inköpet.',
  'buy.title': 'Betalt inköp',
  'buy.subtitle': 'Registrera ett inköp - ladda upp verifikationen, så föreslår vi resten.',
  'buy.drafts': 'Utkast',
  'buy.draftsSub': 'Påbörjade inköp och tillgångar som du inte har bokfört ännu',
  'buy.draftsSearchPh': 'Leverantör, beskrivning, fakturanr eller belopp',
  'buy.showMore': 'Visa fler',
  'buy.noDrafts': 'Inga utkast',
  'buy.invoiceNoShort': 'Fakturanr',
  'buy.delete': 'Ta bort',
  'buy.deleteDraftTitle': 'Ta bort utkast?',
  'buy.deleteDraftConfirm': 'Ja, ta bort utkast',
  'buy.deleteDraftBody': 'Är du säker på att du vill ta bort utkastet för',
  'buy.resetTitle': 'Återställ formuläret och börja om',
  'buy.reset': 'Återställ',
  'buy.howRegister': 'Hur vill du registrera inköpet?',
  'buy.howRegisterSub': 'Ladda gärna upp verifikationen först - så föreslår vi resten åt dig.',
  'buy.stepByStep': 'Steg för steg',
  'buy.stepByStepHelp': 'Leder dig genom inköpet en del i taget - först verifikation, sedan datum, rader och betalning. Bra när du vill ta det lugnt.',
  'buy.stepByStepShort': 'Verifikation först, sedan datum, rader och betalning.',
  'buy.onePage': 'Allt på en sida',
  'buy.onePageHelp': 'Visar hela inköpsformuläret samlat på en sida. Bra när du är van att registrera inköp och vill ha allt framför dig.',
  'buy.onePageShort': 'Hela inköpsformuläret samlat.',
  'buy.toSteps': 'Byt till steg för steg',
  'buy.toOnePage': 'Byt till allt på en sida',
  'buy.back': 'Tillbaka',
  'buy.next': 'Nästa',
  'buy.backToVouchers': 'Tillbaka till transaktioner',
  'buy.salesType': 'Försäljningstyp',
  'buy.paidTo': 'Betalt till',
  'buy.payOperating': 'Företagskonto',
  'buy.payCash': 'Kontant',
  'buy.payPrivate': 'Privat',
  'buy.privateDeposit': 'Privat insättning',
  'buy.whatSold': 'Vad sålde du?',
  'buy.amountExVat': 'Belopp exkl. moms',
  'buy.amountIncVat': 'Belopp inkl. moms',
  'buy.vatLabel': 'Moms',
  'buy.otherSale': 'Annan försäljning',
  'buy.invoiceOrQuote': 'Faktura / offert',
  'buy.switchMode': 'Byt läge',
  'buy.moreOptions': 'Fler val',
  'buy.postAs': 'Bokför som',
  'buy.backendUploadNotReady': 'Backend-uppladdning är inte klar.',
  'buy.multipleUploadedShowFirst': 'Flera verifikationer laddades upp. Visar den första här.',
  'buy.uploadFailed': 'Kunde inte ladda upp verifikationen.',
  'buy.dropReceiptTitle': 'Släpp kvittot här',
  'buy.dropReceiptSubtitle': '...så hjälper vi dig att placera det rätt. Dra in en bild eller PDF, eller tryck för att välja fil.',
  'buy.attachedCount': '{count} verifikationer kopplade',
  'buy.uploading': 'Laddar upp...',
  'buy.chooseFile': 'Välj fil',
  'buy.dropToUpload': 'Släpp verifikationen för att ladda upp',
  'buy.accountFallbackOperating': 'Driftskonto · 1920',
  'buy.accountFallbackCash': 'Kontant',
  'buy.accountFallbackPrivate': 'Privat utlägg',
  'buy.accountFallbackCash1900': 'Kontant - 1900',
  'buy.accountFallbackPrivate2060': 'Privat - 2060',
  'buy.addSupplierQuery': 'Lägg till ”{query}”',
  'buy.chartNotConnected': 'Kontoplanen är inte kopplad till lagring.',
  'buy.accountAdded': 'Kontot har lagts till.',
  'buy.accountSaveFailed': 'Kunde inte spara kontot.',
  'buy.chooseAccount': 'Välj konto',
  'buy.forQuery': 'för ”{query}”',
  'buy.newCustomAccountTitle': 'Nytt egendefinierat konto',
  'buy.saving': 'Sparar...',
  'buy.saveAccount': 'Spara konto',
  'buy.accountNamePlaceholder': 'T.ex. Programvaruutveckling',
  'buy.accountHelperText': 'Kontot blir tillgängligt i kontosökningen och mappas till standardkontot för rapportering och bokslut.',
  'buy.inventoryProduct': 'Lagervara',
  'buy.notTracked': 'Inte lagerförd',
  'buy.quantityInStock': 'Antal in i lager',
  'buy.inStockCount': '{n} i lager',
  'buy.inventoryLineToggle': 'Ska lagerföras',
  'buy.inventoryLineToggleHelp': 'Slå på när köpet ska öka saldot för en registrerad lagervara.',
  'buy.inventorySearchPlaceholder': 'Välj lagervara',
  'buy.inventorySearch': 'Sök på namn, artikelnummer, SKU eller EAN',
  'buy.inventorySearchEmpty': 'Inga lagerförda varor matchar sökningen.',
  'buy.inventoryOpenProducts': 'Öppna produkter',
  'buy.inventoryUnitsInStock': 'i lager',
  'inventoryPurchase.settingsTitle': 'Lagerföring vid köp',
  'inventoryPurchase.settingsHelp': 'Visa ett valfritt lagerfält på köprader, så att ett köp kan öka saldot för en registrerad lagervara.',
  'inventoryPurchase.offHelp': 'Lagerfältet är dolt på nya köp. Produkter och tidigare lagerrörelser behålls.',
  'inventoryPurchase.migratedTitle': 'Lagerföring vid köp är aktiverad',
  'inventoryPurchase.migratedText': 'Företaget har redan produkter med automatisk lagerföring. Därför är lagerkopplingen på köprader aktiverad, så att befintligt arbetsflöde fortsätter.',
  'inventoryPurchase.acknowledge': 'Jag förstår',
  'inventoryPurchase.acknowledgeError': 'Kunde inte spara bekräftelsen.',
  'inventoryPurchase.openSettings': 'Öppna inställningar',
  'inventoryPurchase.disableTitle': 'Stänga av lagerföring vid köp?',
  'inventoryPurchase.disableConfirm': 'Stäng av',
  'inventoryPurchase.disableWarning': 'Lagerfältet döljs på nya köp. Köp kan då inte kopplas till lagerförda produkter, och saldot kan bli fel om det inte kontrolleras och justeras manuellt.',
  'inventoryPurchase.disableHistory': 'Befintliga produkter och historiska lagerrörelser tas inte bort. Inventera lagret och registrera nödvändiga justeringar manuellt.',
  'inventoryPurchase.enabledLabel': 'Lagerföring vid köp',
  'inventoryPurchase.disabledLabel': 'Lagerföring vid köp',
  'buy.noDescription': 'Utan beskrivning',
  'buy.attachmentFallback': 'Verifikation',
  'buy.lockVatTitle': 'Momsperioden är inlämnad',
  'buy.lockYearTitle': 'Räkenskapsåret är avslutat',
  'buy.lockBankTitle': 'Bankperioden är avstämd',
  'buy.lockVatTarget': 'momsperioden',
  'buy.lockYearTarget': 'bokslutet',
  'buy.lockBankTarget': 'bankavstämningen',
  'buy.lockWarningText': '{title}. Du kan fortfarande ändra beskrivning och kostnadskonto/kategori på köpet, men köpdatum, belopp, momskod och betalningsfält är låsta. Öppna eller korrigera {target} om du behöver ändra dessa fält.',
  'buy.lockVatWarningText': '{title}. Köpdatum, belopp och momskod är låsta, men beskrivning, kostnadskonto/kategori och betalningskonto kan fortfarande korrigeras. Öppna eller korrigera {target} om momsunderlaget måste ändras.',
  'buy.backendSaveNotReady': 'Backend-lagring är inte klar.',
  'buy.needAtLeastOneLine': 'Lägg till minst en köprad.',
  'buy.needDescriptionAllLines': 'Lägg in beskrivning på alla rader innan du bokför.',
  'buy.needContentForDraft': 'Lägg till en rad, leverantör eller en verifikation innan du sparar utkastet.',
  'buy.needSupplierForInvoice': 'Välj leverantör eller fyll i leverantörsnamn innan du sparar delbetalning/leverantörsfaktura.',
  'buy.draftSaved': 'Utkast sparat.',
  'buy.attachmentUpdated': 'Verifikationen är uppdaterad.',
  'buy.invoiceRegisteredOpen': 'Fakturan registrerad som öppen leverantörsfaktura.',
  'buy.purchaseBooked': 'Köpet är bokfört! Verifikationen finns nu under Transaktioner.',
  'buy.purchaseSaveFailed': 'Kunde inte spara köpet.',
  'buy.docsFetchedFromInbox': '{count} verifikationer hämtade från inkorgen',
  'buy.fullPayment': 'Full betalning',
  'buy.partPayment': 'Delbetalning',
  'buy.partPaymentWarning': 'Delbetalning registreras som leverantörsfaktura. Resten förs som leverantörsskuld på 2400 tills den betalas.',
  'buy.partPaymentLabel': 'Delbetalning {n}',
  'buy.remainingSuffix': '· återstår',
  'buy.unpaidWillBeInvoice': 'Utan registrerad betalning sparas detta som en öppen leverantörsfaktura. Du kan registrera betalning senare.',
  'buy.forgotReceiptTitle': 'Har du glömt verifikationen?',
  'buy.registerInvoice': 'Registrera faktura',
  'buy.bookPurchase': 'Bokför köp',
  'buy.registerInvoiceHelp': 'Sparar fakturan som öppen leverantörsskuld. Den dyker upp under leverantören, och du registrerar betalning när den är betald.',
  'buy.bookPurchaseHelp': 'Sparar köpet i bokföringen. Verifikationen hamnar under ”Transaktioner”, och beloppen förs på rätt konton.',
  'buy.typeBadgeInvoice': 'Faktura',
  'buy.typeBadgeAsset': 'Tillgång',
  'buy.draftDeleteNotConnected': 'Borttagning av utkast är inte kopplad till backend.',
  'buy.draftDeleted': 'Utkast borttaget.',
  'buy.draftDeleteFailed': 'Kunde inte ta bort utkast.',
  'buy.pageHelpDrafts': 'Här registrerar du allt företaget köper. Välj ”Utkast” i rullgardinsmenyn för att se påbörjade köp som du inte har bokfört ännu.',
  'buy.draftsPageHelp': 'Köp som du har påbörjat men inte slutfört sparas här. Öppna ett utkast för att fortsätta, eller ta bort det du inte behöver.',
  'buy.viewOptionsLabel': 'Visningsval',
  'buy.assetsLabel': 'Tillgångar',
  'buy.noDraftsMatchSearch': 'Inga utkast matchar sökningen.',
  'buy.draftsEmptyHint': 'Påbörjade köp som du sparar som utkast visas här.',
  'buy.colSupplier': 'Leverantör',
  'buy.noSupplier': 'Utan leverantör',
  'buy.colType': 'Typ',
  'buy.colInvoiceNo': 'Fakturanr',
  'buy.colDate': 'Datum',
  'buy.colAmount': 'Belopp',
  'buy.thisPurchaseFallback': 'det här köpet',
  'buy.cannotBeUndone': '? Detta kan inte ångras.',
  'buy.formReset': 'Formuläret har nollställts',
  'buy.editPurchaseSubtitle': 'Uppdatera verifikationen och spara ändringarna i backend.',
  'buy.newPurchasePageHelp': 'Här registrerar du allt företaget köper - varor, utrustning, abonnemang, resor. Ladda upp verifikationen, så läser SuperPlumma av detaljerna och bokför kostnaden på rätt konto med rätt moms.',
  'buy.defaultLineDescription': 'Köp',
  'buy.customerFallback': 'Kund',
  'buy.supplierAndDateTitle': 'Leverantör och datum',
  'buy.supplierAndDateInvoiceHelp': 'Vem du köpte från och när. Fakturadatum är datumet på fakturan, och förfallodatum är när den måste betalas. Fakturanumret är leverantörens eget nummer på fakturan.',
  'buy.supplierAndDatePurchaseHelp': 'Köpdatumet avgör vilken redovisnings- och momsperiod köpet hamnar i. Använd datumet på kvittot.',
  'buy.katFixedAssets': 'Inventarier / utrustning',
  'buy.katRent': 'Hyra',
  'buy.katPhoneInternet': 'Telefon och internet',
  'buy.katSoftware': 'Programvara / abonnemang',
  'buy.katTravel': 'Resor och traktamente',
  'buy.katRepresentation': 'Representation',
  'buy.acct4000': 'Råvaror och halvfabrikat',
  'buy.acct4300': 'Inköp av varor för vidareförsäljning',
  'buy.acct4500': 'Främmande tjänster och underentreprenörer',
  'buy.acct5000': 'Lön till anställda',
  'buy.acct5400': 'Arbetsgivaravgift',
  'buy.acct5900': 'Gåvor till anställda',
  'buy.acct6000': 'Avskrivningar',
  'buy.acct6100': 'Frakt och transportkostnad',
  'buy.acct6200': 'Energi, el och värme',
  'buy.acct6300': 'Lokalhyra',
  'buy.acct6320': 'Renhållning, vatten, avlopp m.m.',
  'buy.acct6340': 'Belysning, värme',
  'buy.acct6360': 'Städning',
  'buy.acct6400': 'Hyra av maskiner',
  'buy.acct6500': 'Verktyg och inventarier',
  'buy.acct6540': 'Inventarier och utrustning',
  'buy.acct6550': 'Förbrukningsmaterial',
  'buy.acct6560': 'Förbrukningsartiklar',
  'buy.acct6600': 'Reparation och underhåll av byggnader',
  'buy.acct6690': 'Reparation och underhåll, övrigt',
  'buy.acct6700': 'Revision och redovisning',
  'buy.acct6720': 'Juridisk rådgivning',
  'buy.acct6790': 'Övriga främmande tjänster',
  'buy.acct6800': 'Kontorsmateriel',
  'buy.acct6810': 'IT-kostnader',
  'buy.acct6820': 'Trycksaker',
  'buy.acct6900': 'Telefon',
  'buy.acct6940': 'Porto',
  'buy.acct7000': 'Drivmedel för transportmedel',
  'buy.acct7020': 'Underhåll bil',
  'buy.acct7040': 'Försäkring och avgifter för transportmedel',
  'buy.acct7100': 'Bilersättning',
  'buy.acct7140': 'Resekostnad, ej uppgiftspliktig',
  'buy.acct7150': 'Traktamentskostnad',
  'buy.acct7160': 'Resekostnad, uppgiftspliktig',
  'buy.acct7300': 'Försäljningskostnad',
  'buy.acct7320': 'Reklam och annonser',
  'buy.acct7350': 'Representation, avdragsgill',
  'buy.acct7360': 'Representation, ej avdragsgill',
  'buy.acct7400': 'Medlemsavgift',
  'buy.acct7500': 'Försäkringspremie',
  'buy.acct7600': 'Licens, patent och royalty',
  'buy.acct7700': 'Övrig rörelsekostnad',
  'buy.acct7770': 'Bank- och kortavgifter',
  'buy.acct7790': 'Övrig kostnad',
  'buy.acct8050': 'Ränteintäkt',
  'buy.acct8150': 'Räntekostnad',
  'buy.acct8300': 'Skatt att betala',
  'buy.fallbackCostName': 'Kostnad',
  'buy.fallbackAccountName': 'Konto',
  'buy.grp40': 'Varukostnad',
  'buy.grp43': 'Varor för vidareförsäljning',
  'buy.grp45': 'Inköp av tjänster',
  'buy.grp50': 'Lön',
  'buy.grp54': 'Arbetsgivaravgift',
  'buy.grp59': 'Personalkostnader',
  'buy.grp60': 'Avskrivningar',
  'buy.grp61': 'Frakt och transport',
  'buy.grp62': 'Energi och värme',
  'buy.grp63': 'Lokaler',
  'buy.grp64': 'Hyra av maskiner och utrustning',
  'buy.grp65': 'Verktyg och inventarier',
  'buy.grp66': 'Reparation och underhåll',
  'buy.grp67': 'Främmande tjänster',
  'buy.grp68': 'Kontorskostnader',
  'buy.grp69': 'Telefon, porto m.m.',
  'buy.grp70': 'Transportmedel',
  'buy.grp71': 'Resor och traktamente',
  'buy.grp73': 'Försäljning och representation',
  'buy.grp74': 'Medlemsavgifter',
  'buy.grp75': 'Försäkring',
  'buy.grp76': 'Licens och royalty',
  'buy.grp77': 'Övriga rörelsekostnader',
  'buy.grp15': 'Kortfristiga fordringar',
  'buy.grp24': 'Leverantörsskulder',
  'buy.groupAssets': 'Tillgångar',
  'buy.groupEquityAndLiabilities': 'Eget kapital och skulder',
  'buy.groupIncome': 'Intäkter',
  'buy.groupCostOfGoods': 'Varukostnad',
  'buy.groupPayrollAndPersonnel': 'Lön och personalkostnader',
  'buy.groupOtherOperating': 'Övriga rörelsekostnader',
  'buy.groupFinanceAndTax': 'Finans och skatt',
  'buy.groupAccountsFallback': 'Konton',
  'rep.trial.onlyMovement': 'Visa bara konton med rörelse',
  'rep.trial.showInactive': 'Visa även inaktiva konton',
  'rep.trial.payrollLiability': 'Löneskuld',
  'rep.trial.holidayPayLiability': 'Semesterlöneskuld',
  'rep.trial.oneEmployee': '{n} anställd',
  'rep.trial.employeeCount': '{n} anställda',
  'rep.trial.otherPayrollLiability': 'Alla konteringar på 2930',
  'rep.trial.allAccountEntries': 'Alla konteringar på {account}',
  'rep.trial.payrollRun': 'Lönekörning {period}',
  'rep.trial.term': 'Period {term} {year}',
  'rep.trial.accrualYear': 'Intjänandeår {year}',
  'vehiclePolicy.dialogTitle': 'Fordon och fordonskostnader',
  'vehiclePolicy.intro': 'Välj hur Plumme ska hantera drivmedel, verkstad och andra tydliga fordonskostnader. Detta är en arbetsinställning för verifikationsförslag och registrerar inte ett fordon som tillgång.',
  'vehiclePolicy.optionVat': 'Fordon med momsavdrag',
  'vehiclePolicy.optionVatSub': 'Företaget äger eller leasar fordonet, fordonstypen ger avdragsrätt, och kostnaden gäller registrerad momspliktig verksamhet.',
  'vehiclePolicy.optionNoVat': 'Fordon utan momsavdrag',
  'vehiclePolicy.optionNoVatSub': 'Föreslå fordonskostnaden utan avdrag för ingående moms.',
  'vehiclePolicy.optionManual': 'Kontrollera varje verifikation manuellt',
  'vehiclePolicy.optionManualSub': 'Plumme föreslår konto, men lämnar momsavdraget för kontroll.',
  'vehiclePolicy.validFrom': 'Gäller från',
  'vehiclePolicy.noEndDateWarning': 'Utan slutdatum gäller valet tills du ändrar det. Ett nytt val avslutar automatiskt det föregående från ändringsdatumet.',
  'vehiclePolicy.responsibility': 'Jag bekräftar att uppgiften är korrekt och förstår att jag själv måste uppdatera den om fordonet säljs, leasingavtalet avslutas eller fordonstypen eller användningen ändras.',
  'vehiclePolicy.receiptTitle': 'Klargör fordonet en gång',
  'vehiclePolicy.receiptText': 'Då kan senare drivmedels- och verkstadsverifikationer få rätt momsförslag automatiskt.',
  'vehiclePolicy.changeFromReceiptTitle': 'Ändra fordonsregeln?',
  'vehiclePolicy.changeFromReceiptText': 'Du har satt den här fordonsverifikationen till 0 % momsavdrag. Ska det bara gälla den här verifikationen, eller ska Plumme hantera fordonskostnader utan momsavdrag framöver eftersom fordonet är sålt, leasingen har avslutats eller avdragsrätten inte längre gäller?',
  'vehiclePolicy.changeFromReceiptDate': 'Den nya regeln gäller från {date}.',
  'vehiclePolicy.receiptOnly': 'Bara den här verifikationen',
  'vehiclePolicy.updateToNoVat': 'Använd 0 % framöver',
  'vehiclePolicy.settingsTitle': 'Fordon och fordonskostnader',
  'vehiclePolicy.settingsText': 'Styr automatiska förslag för drivmedel, verkstad och andra tydliga fordonskostnader. Inställningen bokför inget och skapar ingen tillgång eller något leasingavtal.',
  'vehiclePolicy.choose': 'Välj inställning',
  'vehiclePolicy.change': 'Ändra inställning',
  'vehiclePolicy.save': 'Spara och använd',
  'vehiclePolicy.saved': 'Fordonsinställningen har sparats.',
  'vehiclePolicy.saveError': 'Fordonsinställningen kunde inte sparas.',
  'vehiclePolicy.chooseError': 'Välj hur fordonsverifikationer ska hanteras.',
  'vehiclePolicy.confirmError': 'Bekräfta att företaget självt håller uppgiften uppdaterad.',
  'vehiclePolicy.notConfigured': 'Inte konfigurerad – fordonsverifikationer måste kontrolleras',
  'vehiclePolicy.activeFrom': 'Gäller från',
  'vehiclePolicy.noEndDate': 'inget slutdatum',
  'vehiclePolicy.mode.vat_deductible': 'Fordon med momsavdrag',
  'vehiclePolicy.mode.no_vat_deduction': 'Fordon utan momsavdrag',
  'vehiclePolicy.mode.manual_review': 'Manuell kontroll av varje verifikation',
  'buy.vatDeduction': 'Avdrag för ingående moms',
  'buy.vatDeductionFull': '100 %',
  'buy.vatDeductionNone': '0 %',
  'buy.vatDeductionPartial': 'Delvis',
  'buy.vatDeductionPercent': 'Avdragsprocent',
  'buy.fixedAssetLine': 'Registrera raden som tillgång',
  'buy.fixedAssetLineHelp': 'Raden läggs till i tillgångsregistret i stället för att bara behandlas som kostnad.',
  'buy.fixedAssetFallback': 'Anläggningstillgång',
  'buy.projectForLine': 'Projekt för den här raden',
  'sup.credit.created': 'Leverantörens kreditfaktura har bokförts.',
  'sup.credit.refunded': 'Återbetalningen har bokförts.',
  'sup.credit.title': 'Registrera leverantörskreditfaktura',
  'sup.credit.refundTitle': 'Registrera återbetalning av kreditfaktura',
  'sup.credit.action': 'Bokför kreditfaktura',
  'sup.credit.refundAction': 'Registrera återbetalning',
});
